var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-box',{class:_vm.name,attrs:{"text":_vm.$t('module_ad_shop_live_ads_schedule_dst_hint'),"link-text":_vm.$t('common_learn_more'),"link-url":"/help/article?aid=10009407"}})}
var staticRenderFns = []

export { render, staticRenderFns }